export default "__VITE_ASSET__DilUxKv0__"